import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import SidebarContainer from '../SidebarContainer';
import * as analyticsActions from '../../redux/analytics/actions';
import { ResultsUser } from '../../components/ResultsDashboard';
import { useQueryDate } from './hooks/useQueryDate';
import './styles.scss';

function Results(props) {
  const [queryDate, setQueryDate] = useQueryDate(props);

  const onDateRangeChange = (start, end) => {
    setQueryDate({
      start,
      end,
    });
  };

  if (!props.dealer.id) return null;

  return (
    <SidebarContainer title={props.dealer.name}>
      <div id="results" className="user-results">
        <button className="btn" onClick={() => props.history.goBack()}>
          Back To All
        </button>
        <div className="tab-content">
          <ResultsUser
            fetchLocal
            queryDate={{ ...queryDate }}
            onDateRangeChange={onDateRangeChange}
            deals={props.storeDeals}
            fetchDeals={props.actions.analyticsStoreDealsRequest}
          />
        </div>
      </div>
    </SidebarContainer>
  );
}

Results.propTypes = {
  actions: PropTypes.object.isRequired,
  dealer: PropTypes.object.isRequired,
  storeDeals: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

const mapStateToProps = ({ analytics, user }) => ({
  dealer: user.currentUserDealer,
  storeDeals: analytics.storeDeals,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(analyticsActions, dispatch),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Results),
);
